import Select from "components/shared/select";
import moment from "moment";
import React from "react";

const Filter = ({ getList, filter, setFilter }) => {
    const minYear = 2021;
    const minMonth = "09";
    const currentYear = moment().year();
    const currentMonth = moment().format("MM");
    const monthsOptions = [
        { label: "Январь", value: "01" },
        { label: "Февраль", value: "02" },
        { label: "Март", value: "03" },
        { label: "Апрель", value: "04" },
        { label: "Май", value: "05" },
        { label: "Июнь", value: "06" },
        { label: "Июль", value: "07" },
        { label: "Август", value: "08" },
        { label: "Сентябрь", value: "09" },
        { label: "Октябрь", value: "10" },
        { label: "Ноябрь", value: "11" },
        { label: "Декабрь", value: "12" },
    ];

    const getOptionsByName = (name) => {
        switch (name) {
            case "month": {
                return currentYear === minYear
                    ? monthsOptions.slice(parseInt(minMonth) - 1, parseInt(currentMonth))
                    : filter.year === minYear
                      ? monthsOptions.splice(parseInt(minMonth) - 1, monthsOptions.length)
                      : filter.year === currentYear
                        ? monthsOptions.splice(0, parseInt(currentMonth))
                        : monthsOptions;
            }
            case "year": {
                const yearOptions = [];
                let i = minYear;
                while (i <= currentYear) {
                    yearOptions.push({ label: i.toString(), value: i });
                    i++;
                }
                return yearOptions;
            }
        }
    };

    const onChange = ({ name, value }) => {
        if (name === "year") {
            value === minYear && parseInt(filter.month) < parseInt(minMonth) && (filter.month = minMonth);
            value === currentYear && parseInt(filter.month) > parseInt(currentMonth) && (filter.month = currentMonth);
        }
        setFilter({ ...filter, [name]: value });
    };

    const getConfigByPropName = (name) => ({
        inputProps: { name },
        options: getOptionsByName(name),
        value: filter[name],
        onChange,
        styles: {
            container: (styles) => ({ ...styles, minWidth: "150px" }),
        },
    });

    return (
        <div className="d-flex align-items-center mb-2">
            <div className="mr-2">
                <Select {...getConfigByPropName("month")} />
            </div>
            <div className="mr-2">
                <Select {...getConfigByPropName("year")} />
            </div>
            <a className="btn btn-brand btn-sm" onClick={() => getList(filter)}>
                Сформировать
            </a>
        </div>
    );
};

export default Filter;
